import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { CitationViewerContent } from "@/features/chat/components/citation-viewer-content"
import { getProjectFileContentUrl } from "@/services/project-service"

type ProjectFilePreviewDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  projectId: string
  /** Filename to preview, or null while the dialog is closed/transitioning. */
  filename: string | null
}

/**
 * Preview a project file inline using the same extension-based viewer
 * dispatch as the citation/session-file preview panel (CitationViewerContent
 * -> useCitation().renderComponent) -- no new viewer logic, just pointed at
 * the project-file content route instead of a citation/session URL.
 */
export function ProjectFilePreviewDialog({
  open,
  onOpenChange,
  projectId,
  filename,
}: ProjectFilePreviewDialogProps) {
  const fileUrl = filename ? getProjectFileContentUrl(projectId, filename) : null

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex h-[85vh] max-w-4xl flex-col gap-0 overflow-hidden p-0">
        {filename && fileUrl && (
          <>
            <DialogHeader className="shrink-0 border-b px-4 py-3">
              <DialogTitle className="truncate pr-8 text-base" title={filename}>
                {filename}
              </DialogTitle>
            </DialogHeader>
            <div className="min-h-0 flex-1 overflow-hidden">
              <CitationViewerContent chunkSnippet="" documentUrl={fileUrl} quoteSnippet="" />
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  )
}
